import { render, staticRenderFns } from "./ModalRight.vue?vue&type=template&id=1e52a708"
import script from "./ModalRight.vue?vue&type=script&lang=js"
export * from "./ModalRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports